import { Box, Flex, Text } from "@chakra-ui/layout";
import {
  Slider as ChakraSlider,
  SliderFilledTrack,
  SliderThumb,
  SliderTrack,
} from "@chakra-ui/slider";

function Slider({ setZoom, zoom }) {
  return (
    <>
      <Flex justify="center" px={3} mb={3}>
        <Box w="100%" maxW={500} rounded={"1xl"} boxShadow={"1xl"}>
          <Text textDecoration="underline" letterSpacing="wide">
            Number of Columns:
          </Text>
          <ChakraSlider
            defaultValue={10}
            min={1}
            max={20}
            step={1}
            onChangeEnd={(val) => setZoom(val)}
            focusThumbOnChange={false}
            maxW={500}
            colorScheme="purple"
            justifySelf="center"
          >
            <SliderTrack>
              <Box position="relative" right={10} />
              <SliderFilledTrack />
            </SliderTrack>
            <SliderThumb boxSize={6}>
              <Text
                fontWeight="semibold"
                display="flex"
                justifyContent="center"
                alignItems="center"
                alignSelf="center"
                color="purple"
                pb={0.5}
              >
                {zoom}
              </Text>
            </SliderThumb>
          </ChakraSlider>
        </Box>
      </Flex>
    </>
  );
}

export default Slider;
